import { useL10n } from "@ews/react-localization-context";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsNumberInput from "../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsDateInput from "../../../Settings/SettingsComponents/SettingsDateInput/SettingsDateInput";

const System: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>
        <SettingsCheckbox
            text={t("TRVB_OFFICIALLY_REQUIRED_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_OFFICIALLY_REQUIRED_DESC")} />}
            checked={specification.systemInformation?.legallyRequired || false}
            onChange={(checked) =>
            {
                if (specification.systemInformation?.legallyRequired === checked) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            legallyRequired: checked
                        },
                    });
                }
            }} />
        <SettingsTextInput
            text={t("TRVB_AUTHORITY_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_AUTHORITY_LABEL")} />}
            value={specification.systemInformation?.authority}
            onBlur={({ value }) =>
            {
                if (specification.systemInformation?.authority === value) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            authority: value
                        },
                    });
                }
            }
            } />
        <SettingsNumberInput
            text={t("[REACT_NUMBER]")}
            tooltip={<TooltipIcon text={t("[REACT_NUMBER]")} />}
            value={specification.systemInformation?.number || 0}
            onBlur={({ value }) =>
            {
                if (specification.systemInformation?.number === value) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            number: value
                        },
                    });
                }
            }
            } />
        <SettingsDateInput value={specification.systemInformation?.date} text={t('TRVB_DATE_LABEL')} onBlur={({ value }) =>
        {
            const date = value.toISOString();
            if (specification.systemInformation?.date === date) return;
            if (systemId && specification.systemInformation) {

                modifySystemSpecification(systemId, {
                    ...specification,
                    systemInformation: {
                        ...specification.systemInformation,
                        date
                    },
                });
            }
        }} />
        <SettingsTextInput
            text={t("TRVB_FIRE_PROTECTION_CONCEPT_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FIRE_PROTECTION_CONCEPT_LABEL")} />}
            value={specification.systemInformation?.fireProtectionConceptCreatedBy}
            onBlur={({ value }) =>
            {
                if (specification.systemInformation?.fireProtectionConceptCreatedBy === value) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            fireProtectionConceptCreatedBy: value
                        },
                    });
                }
            }
            } />
        <SettingsTextInput
            text={t("TRVB_FIREDEPARTMENT_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FIREDEPARTMENT_LABEL")} />}
            value={specification.systemInformation?.responsibleFireDepartment}
            onBlur={({ value }) =>
            {
                if (specification.systemInformation?.responsibleFireDepartment === value) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            responsibleFireDepartment: value
                        },
                    });
                }
            }
            } />
        <SettingsCheckbox
            text={t("TRVB_COMPANY_FIRE_BRIGADE_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_COMPANY_FIRE_BRIGADE_LABEL")} />}
            checked={specification.systemInformation?.companyFireBrigade || false}
            onChange={(checked) =>
            {
                if (specification.systemInformation?.companyFireBrigade === checked) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            companyFireBrigade: checked
                        },
                    });
                }
            }} />

        <SettingsTextInput
            text={t("TRVB_MAIL_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_MAIL_LABEL")} />}
            value={specification.systemInformation?.email}
            onBlur={({ value }) =>
            {
                if (specification.systemInformation?.email === value) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            email: value
                        },
                    });
                }
            }
            } />

        <SettingsCheckbox
            text={t("[REACT_NEW_INSTALLATION]")}
            tooltip={<TooltipIcon text={t("[REACT_NEW_INSTALLATION]")} />}
            checked={specification.systemInformation?.newInstallation || false}
            onChange={(checked) =>
            {
                if (specification.systemInformation?.newInstallation === checked) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            newInstallation: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_EXPANSION]")}
            tooltip={<TooltipIcon text={t("[REACT_EXPANSION]")} />}
            checked={specification.systemInformation?.extension || false}
            onChange={(checked) =>
            {
                if (specification.systemInformation?.extension === checked) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            extension: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_MODIFICATION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_MODIFICATION_LABEL")} />}
            checked={specification.systemInformation?.modification || false}
            onChange={(checked) =>
            {
                if (specification.systemInformation?.modification === checked) return;
                if (systemId && specification.systemInformation) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        systemInformation: {
                            ...specification.systemInformation,
                            modification: checked
                        },
                    });
                }
            }} />
    </>;
};

export default System;
